export const renderReadingTime = t => {
	if (t >= 60) {
		const hours = Math.trunc(t / 60);
		const minutes = Math.trunc(t % 60);
		return `${hours} ${hours === 1 ? "hora" : "horas"} con ${minutes} ${minutes === 1 ? "minuto" : "minutos"}`;
	}

	return `${t} ${t === 1 ? "minuto" : "minutos"}`.replace(".", ":");
};
